import { COMPONENT_HUB_API_PATH } from '@config/constant';

export const PROFILE_API_PREFIX = `${COMPONENT_HUB_API_PATH}/profile`;

export const TEMPLATE_API_PREFIX = '/api/xy/template/component';


